import { Directive, OnInit, TemplateRef, ViewContainerRef, Input } from '@angular/core';
import { InfineScrollLoaderService } from '../services/infine-scroll-loader.service';

@Directive({
  selector: '[appInfinitescroll]'
})
export class InfinitescrollDirective implements OnInit {

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private scrollLoaderService: InfineScrollLoaderService
  ) { }

  condition: boolean;
  prevCondition: boolean = false;

  ngOnInit() {
    this.scrollLoaderService.scrollStatus.subscribe((val: boolean) => {
      if (val && this.condition || !val && !this.condition) {
        if (this.prevCondition != val) {
          this.prevCondition = val;
          this.viewContainer.createEmbeddedView(this.templateRef);
        }
      } else {
        if (this.prevCondition != val) {
          this.prevCondition = val;
          this.viewContainer.clear();
        }
      }
    });
  }

  @Input() set appInfinitescroll(condition: boolean) {
    this.condition = condition;
  }


}



// WEBPACK FOOTER //
// ./src/app/shared/directives/infinitescroll.directive.ts